import { ContactDetails } from '@/components/ContactForm';

export type DataExchangeEmailOption = {
  label1: string;
  label2: string;
  value: string;
};

export const buildDataExchangeEmailOptions = (contacts: ContactDetails[]): DataExchangeEmailOption[] => {
  const groupedByEmail = new Map<string, { value: string; names: string[] }>();

  contacts.forEach((contact) => {
    const rawEmail = contact.email;
    if (!rawEmail?.trim()) return;

    const name = `${contact.firstName ?? ''} ${contact.lastName ?? ''}`.trim();
    const key = rawEmail.trim().toLowerCase();
    const existing = groupedByEmail.get(key);

    if (existing) {
      if (name && !existing.names.includes(name)) existing.names.push(name);
      return;
    }

    groupedByEmail.set(key, { value: rawEmail, names: name ? [name] : [] });
  });

  return Array.from(groupedByEmail.values()).map(({ value, names }) => {
    const holders = names.join(', ');
    return {
      label1: holders ? `${holders} - ${value}` : value,
      label2: holders || value,
      value,
    };
  });
};
